import { Link } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';

/** Landing page after sign-in: who you are and what you can do next. */
export function DashboardPage() {
  const { user, pcc } = useAuth();
  if (!user) return null;

  const displayName = `${user.firstName} ${user.lastName}`.trim() || user.userId;
  const canManageUsers = user.role === 'root' || user.role === 'admin';

  return (
    <>
      <div className="page-header">
        <div>
          <h1 className="page-header__title">Welcome, {displayName}</h1>
          <p className="page-header__subtitle">
            You are signed in to the Agency Workspace{pcc ? ` under PCC ${pcc}` : ''}.
          </p>
        </div>
      </div>

      <div className="card-grid">
        <div className="card">
          <div className="card__body">
            <div className="stat__label">Signed in as</div>
            <div className="stat__value mono">{user.userId}</div>
            <div className="stat__hint">
              <span className={`badge badge--${user.role}`}>{user.role}</span>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card__body">
            <div className="stat__label">Pseudo city code</div>
            <div className="stat__value mono">{pcc || '—'}</div>
            <div className="stat__hint">{user.pcc ? `Home PCC ${user.pcc}` : 'No home PCC assigned'}</div>
          </div>
        </div>

        <div className="card">
          <div className="card__body">
            <div className="stat__label">Last sign-in</div>
            <div className="stat__value" style={{ fontSize: 20 }}>
              {user.lastLoginAt ? new Date(user.lastLoginAt).toLocaleString() : 'First session'}
            </div>
            <div className="stat__hint">Account created {new Date(user.createdAt).toLocaleDateString()}</div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card__body">
          <h2 style={{ fontSize: 20, fontWeight: 400, marginBottom: 8 }}>Next steps</h2>
          <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9 }}>
            <li>
              <Link className="spark-link" to="/">
                Open the workspace
              </Link>{' '}
              — the host command line, where flights are searched and sold.
            </li>
            {canManageUsers && (
              <li>
                <Link className="spark-link" to="/admin/users">
                  Manage users
                </Link>{' '}
                — create accounts, reset passwords and disable access.
              </li>
            )}
            {user.role === 'root' && (
              <li>
                <Link className="spark-link" to="/admin/audit">
                  Review activity
                </Link>{' '}
                — sign-in attempts and administrative changes.
              </li>
            )}
            <li>
              <Link className="spark-link" to="/change-password">
                Change your password
              </Link>{' '}
              — rotating it ends every other active session.
            </li>
            <li>
              <Link className="spark-link" to="/security">
                {user.twoFactorEnabled ? 'Manage two-step verification' : 'Turn on two-step verification'}
              </Link>{' '}
              — sign in with a code from Google Authenticator as well as your password.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
